import React from 'react';
import cn from 'classnames';
import {StandardProps} from '.';


export interface FormHelperTextProps extends StandardProps<React.HTMLAttributes<HTMLParagraphElement>> {
  error?: boolean;
}

export const FormHelperText = React.forwardRef<HTMLParagraphElement, FormHelperTextProps>((props, ref) => {
  const {
    children,
    className,
    error,
    ...other
  } = props;

  return (
    <p
      className={cn(
        'form-helper-text form-helper-text__root',
        'm-0 pt-1',
        'body3-regular sm:body3-regular leading-12',
        className,
        {
          [`form-helper-text__root--error`]: error,
        },
      )}
      ref={ref}
      {...other}
    >
      {children === ' ' ? <span className="notranslate">&#8203;</span> : children}
    </p>
  );
});

export default FormHelperText;
